import React, { useEffect, useState } from 'react';
import { trackPlayStoreClick, PLAY_STORE_URL } from './track';

// Small persistent download nudge that appears once the hero has scrolled
// out of view, and hides again near the final CTA section to avoid
// duplicating the same button right next to itself.
const StickyCta = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const update = () => {
      ticking = false;
      const hero = document.getElementById('topo');
      const finalCta = document.getElementById('final-heading');
      if (!hero) return;

      const heroBottom = hero.getBoundingClientRect().bottom;
      const nearFinal = finalCta
        ? finalCta.getBoundingClientRect().top < window.innerHeight
        : false;

      setVisible(heroBottom < 0 && !nearFinal);
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`dd-sticky-cta ${visible ? 'dd-sticky-cta--visible' : ''}`} aria-hidden={!visible}>
      <span>DropsDay — Clara IA para acompanhar sua jornada</span>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="dd-btn dd-btn--primary"
        onClick={() => trackPlayStoreClick('sticky_bar')}
        tabIndex={visible ? 0 : -1}
      >
        Baixar
      </a>
    </div>
  );
};

export default StickyCta;
